module.exports = __webpack_public_path__ + "static/media/tv_couch.9d868381.jpeg";